module.exports = {
          srcSet: __webpack_public_path__ + "883b5a652dafb67a11cb285d71452deb-66.jpg"+" 66w",
          images:[ {path: __webpack_public_path__ + "883b5a652dafb67a11cb285d71452deb-66.jpg",width: 66,height: 26}],
          src: __webpack_public_path__ + "883b5a652dafb67a11cb285d71452deb-66.jpg",
          toString:function(){return __webpack_public_path__ + "883b5a652dafb67a11cb285d71452deb-66.jpg"},
          
          width: 66,
          height: 26
        }